module.exports = __webpack_public_path__ + "static/media/no.9ca2dcac.jpeg";